{
  "mainLJ": {
    "title": "Diario del pilota (aliante)",
    "nazaj": "Indietro"
  },
  "navsLJ": {
    "vnos": "Inserimento",
    "dnevnik": "Diario"
  },
  "labelsLJ": {
    "datum": "Data:",
    "casO": "Ora di partenza:",
    "krajV": "Luogo di decollo: LJAJ",
    "naloga": "Compito",
    "stLetov": "Numero di voli",
    "casP": "Ora di arrivo:",
    "krajP": "Luogo di atterraggio: LJAJ",
    "model": "Tipo",
    "reg": "Registrazione aeromobile: S5-XYZ",
    "nacinStarta": "Metodo di lancio",
    "ime": "Nome del comandante",
    "posadka": "Equipaggio singolo / multiplo:",
    "posadkaVec": "MULTI",
    "skupniCas": "Tempo totale di volo:",
    "stPristankovDN": "Numero di atterraggi (Giorno / Notte):",
    "dan": "Giorno",
    "noc": "Notte",
    "stPristankov": "Numero di atterraggi:",
    "op": "Condizioni operative:",
    "opD": "Giorno",
    "opN": "Strumentale",
    "vlogaP": "Ruolo del pilota:",
    "fstd": "Tempo totale FSTD:",
    "kilometri": "Chilometri percorsi",
    "opomba": "Nota"
  },
  "buttonsLJ": {
    "vnesiZapis": "Aggiungi voce"
  },
  "optionsLJ": {
    "aerozaprega": "Traino aereo",
    "vitla": "Verricello"
  },
  "obvestilaLJ": {
    "zapisDodan": "Voce aggiunta con successo.",
    "napakaVnosa": "Errore durante l'inserimento dei dati.",
    "napakaInputa": "Tutti i campi devono essere compilati per aggiungere una voce. Verifica di aver inserito tutti i dati!",
    "napakaBranja": "Errore durante la lettura dei dati."
  }
}